import React from "react";
import { Box, Button, Chip, TextField, Typography } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ScienceIcon from "@mui/icons-material/Science";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTranslation } from "react-i18next";

export default function HeroSection({
  receiverRowCount,
  donorRowCount,
  reportFromStr,
  reportToStr,
  setReportFromStr,
  setReportToStr,
  onExportReportPpt,
}) {
  const { t } = useTranslation();

  return (
    <Box className="rxghg_hero">
      <Box className="rxghg_heroLeft">
        <Box className="rxghg_heroIcon">
          <AssessmentIcon />
        </Box>

        <Box className="rxghg_heroCopy">
          <Typography className="rxghg_heroTitle">
            {t("ghg.hero.title")}
          </Typography>

          <Typography className="rxghg_heroSub">
            {t("ghg.hero.subtitle")}
          </Typography>

          <Box className="rxghg_heroChips">
            <Chip
              className="rxghg_chip"
              icon={<ScienceIcon />}
              label={t("ghg.hero.receiverFactors", {
                count: receiverRowCount,
              })}
              size="small"
              variant="outlined"
            />
            <Chip
              className="rxghg_chip"
              icon={<LocalShippingIcon />}
              label={t("ghg.hero.donorAllocations", {
                count: donorRowCount,
              })}
              size="small"
              variant="outlined"
            />
          </Box>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <TextField
              size="small"
              type="date"
              label={t("ghg.hero.reportFrom")}
              InputLabelProps={{ shrink: true }}
              value={reportFromStr}
              onChange={(e) => setReportFromStr(e.target.value)}
            />
            <TextField
              size="small"
              type="date"
              label={t("ghg.hero.reportTo")}
              InputLabelProps={{ shrink: true }}
              value={reportToStr}
              onChange={(e) => setReportToStr(e.target.value)}
            />
            <Button
              className="rxghg_btn"
              variant="contained"
              size="small"
              onClick={onExportReportPpt}
            >
              {t("ghg.hero.exportButton")}
            </Button>
          </Box>

          <Typography
            variant="caption"
            sx={{ opacity: 0.7, mt: 1, display: "block" }}
          >
            {t("ghg.hero.exportHint")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
